// extracted by mini-css-extract-plugin
export default {"hoverButton":"ViewTabs_hoverButton__7+eq+","viewTabs":"ViewTabs_viewTabs__QmlDm"};